export function formatDate(input: string | null | undefined): string {
  if (!input) return '—';
  try {
    const d = new Date(input);
    return d.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return input;
  }
}

export function formatRelative(input: string | null | undefined): string {
  if (!input) return '—';
  const ms = Date.now() - Date.parse(input);
  if (!Number.isFinite(ms)) return formatDate(input);
  const sec = Math.round(ms / 1000);
  const abs = Math.abs(sec);
  const fmt = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
  if (abs < 60) return fmt.format(-sec, 'second');
  if (abs < 3600) return fmt.format(-Math.round(sec / 60), 'minute');
  if (abs < 86_400) return fmt.format(-Math.round(sec / 3600), 'hour');
  if (abs < 86_400 * 30) return fmt.format(-Math.round(sec / 86_400), 'day');
  if (abs < 86_400 * 365) return fmt.format(-Math.round(sec / (86_400 * 30)), 'month');
  return fmt.format(-Math.round(sec / (86_400 * 365)), 'year');
}

export function formatNumber(n: number | null | undefined): string {
  if (n == null) return '—';
  return new Intl.NumberFormat().format(n);
}

export function shortUrlFor(code: string, baseUrl?: string): string {
  const base = (baseUrl ?? `${window.location.protocol}//${window.location.host}`).replace(
    /\/$/,
    '',
  );
  return `${base}/${code}`;
}
